
import { statusList } from '@/utils/constants';
import { StatusItem } from '@/utils/models';
import StatusIcon from './StatusIcon.vue';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({ components: { StatusIcon } })
export default class StatusSetPanel extends Vue {
  list: StatusItem[] = [];
  @Prop()
  currentId!: string;
  @Prop() selectingIndex!: number;

  mounted() {
    this.list = statusList.filter((v) => v.selectable);
  }
  @Emit()
  changeStatus(staus: StatusItem) {}
}
